import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { HomePage } from './components/HomePage';
import { LoginPage } from './components/LoginPage';
import { RegisterPage } from './components/RegisterPage';
import { BookSelectionPage } from './components/BookSelectionPage';
import { GamePage } from './components/GamePage';
import { CollectionPage } from './components/CollectionPage';
import { RankingPage } from './components/RankingPage';
import { ProfilePage } from './components/ProfilePage';
import { SupportPage } from './components/SupportPage';
import { AboutPage } from './components/AboutPage';
import { AuthCallback } from './components/AuthCallback';
import { AuthRedirectPage } from './components/AuthRedirectPage';
import { ToastProvider } from './context/ToastContext';
import { ToastContainer } from './components/ToastContainer';
import { useGameToasts } from './hooks/useGameToasts';
import '@/App.css';

function AppContent() {
  const { toastWelcome } = useGameToasts();

  React.useEffect(() => {
    // Cuando carga la app
    const user = JSON.parse(localStorage.getItem('sb-yymxpxqizszyqclvdfsk-auth-token')) || JSON.parse(localStorage.getItem('user'));
    if (user && user.user && user.user.user_metadata) {
      toastWelcome(user.user.user_metadata.full_name || user.user.user_metadata.name || 'Jugador');
    } else if (user && user.nombre) {
      toastWelcome(user.nombre);
    }
  }, [toastWelcome]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/select-book" element={<BookSelectionPage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/collection" element={<CollectionPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/auth" element={<AuthRedirectPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
}

export default App;
